import { render, staticRenderFns } from "./supplierNewsList.vue?vue&type=template&id=485c8ad1&scoped=true&"
import script from "./supplierNewsList.vue?vue&type=script&lang=js&"
export * from "./supplierNewsList.vue?vue&type=script&lang=js&"
import style0 from "./supplierNewsList.vue?vue&type=style&index=0&id=485c8ad1&scoped=true&lang=css&"
import style1 from "./supplierNewsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c8ad1",
  null
  
)

export default component.exports